"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationPreferencesGroup = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _NotificationPreferencesItem = require("./NotificationPreferencesItem");
var _components = require("../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ConfigurationRestriction = function ConfigurationRestriction(_ref) {
  var restrictions = _ref.restrictions;
  if (!(restrictions !== null && restrictions !== void 0 && restrictions.includes('one-active'))) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_components.Tooltip, {
    title: "At least one channel should be active"
  }, ' ', /*#__PURE__*/_react.default.createElement(_components.Icon, {
    className: "cursor-pointer",
    type: "info",
    size: 16
  }));
};
var NotificationPreferencesGroup = function NotificationPreferencesGroup(_ref2) {
  var items = _ref2.items,
    note = _ref2.note,
    title = _ref2.title,
    restrictions = _ref2.restrictions,
    phoneChangeDescription = _ref2.phoneChangeDescription,
    phoneChangeCta = _ref2.phoneChangeCta,
    onPhoneChange = _ref2.onPhoneChange;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-notifications-settings-group card mb-[24px] px-[24px] pt-[24px] pb-[32px] flex flex-col gap-y-[16px]"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "tw-subtitle-sm-medium text-black"
  }, title, /*#__PURE__*/_react.default.createElement(ConfigurationRestriction, {
    restrictions: restrictions
  })), items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_NotificationPreferencesItem.NotificationPreferencesItem, _extends({
      key: item.name
    }, item, {
      phoneChangeDescription: phoneChangeDescription,
      phoneChangeCta: phoneChangeCta,
      onPhoneChange: onPhoneChange
    }));
  }), note ? /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-group-note"
  }, note) : '');
};
exports.NotificationPreferencesGroup = NotificationPreferencesGroup;
NotificationPreferencesGroup.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    checked: _propTypes.default.bool,
    description: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    onChange: _propTypes.default.func,
    title: _propTypes.default.string
  })),
  note: _propTypes.default.string,
  title: _propTypes.default.string,
  onPhoneChange: _propTypes.default.func.isRequired
};